import { Col, Row } from "antd";
import React from "react";
import ContactDetailsCard from "./ContactDetailsCard";
import { FaXTwitter } from "react-icons/fa6";
import { FaInstagram, FaLinkedinIn } from "react-icons/fa";
import { TbBrandYoutube } from "react-icons/tb";
import map from "../../../assets/icons/location.svg";
import clock from "../../../assets/icons/clock.svg";
import mail from "../../../assets/icons/email.svg";
import phone from "../../../assets/icons/telephoner.svg";

const ContactDetails = () => {
  const cardData = [
    {
      title: "العنوان",
      info: [
        "حي المبعوث , شارع كنانة بن عبد ياليل ,   ",
        " 42362 المدينة المنورة ",
        "المملكة العربية السعودية",
      ],
      icon: <img width={50} src={map} alt="" />,
    },
    {
      title: "البريد الإلكتروني",
      info: ["info@takaful.sa", "care@takaful.sa"],
      icon: <img width={50} src={mail} alt="" />,
    },
    {
      title: "رقم الهاتف ",
      info: ["920001737"],
      icon: <img width={50} src={phone} alt="" />,
    },
    {
      title: "من الأحد إلى الخميس",
      info: ["من الساعة 07:30", "إلى الساعة 03:30"],
      icon: <img width={50} src={clock} alt="" />,
    },
  ];
  return (
    <div className="takaful--contact-us-Details">
      <p className="takaful--contact-us-Details-desc">نسعد بتواصلكم</p>
      <Row justify={"space-between"}>
        {cardData?.map((card, index) => (
          <Col
            key={index}
            xxl={11}
            xl={10}
            lg={24}
            md={24}
            sm={24}
            xs={24}
            style={{ marginBottom: "2rem" }}
          >
            <ContactDetailsCard
              title={card?.title}
              info={card?.info}
              icon={card?.icon}
            />
          </Col>
        ))}
      </Row>
      <Row className="takaful--contact-us-details-social" align={"middle"}>
        <Col xxl={13} xl={14} lg={10} md={14} sm={24} xs={24}>
          <p className="takaful--contact-us-Details-desc">
            تابعونا عبر وسائل التواصل الاجتماعي :
          </p>
        </Col>
        <Col xxl={10} xl={10} lg={10} md={10} sm={24} xs={24}>
          <Row
            style={{ gap: "0.7rem" }}
            gutter={16}
            className="takaful--contactUs-icons"
          >
            <Col
              className="takaful--contactUs-icon-container"
              xxl={4}
              xl={4}
              lg={5}
              md={5}
              sm={5}
              xs={5}
              onClick={() => {
                window.open("https://www.instagram.com/takafulsa");
              }}
            >
              <FaInstagram color="#000" size={17} />
            </Col>

            <Col
              className="takaful--contactUs-icon-container"
              xxl={4}
              xl={4}
              lg={5}
              md={5}
              sm={5}
              xs={5}
              onClick={() => {
                window.open(
                  "https://www.linkedin.com/in/%D8%AC%D9%85%D8%B9%D9%8A%D8%A9-%D8%AA%D9%83%D8%A7%D9%81%D9%84-%D8%A7%D9%84%D8%AE%D9%8A%D8%B1%D9%8A%D8%A9-%D9%84%D8%B1%D8%B9%D8%A7%D9%8A%D8%A9-%D8%A7%D9%84%D8%A3%D9%8A%D8%AA%D8%A7%D9%85-%D8%A8%D8%A7%D9%84%D9%85%D8%AF%D9%8A%D9%86%D8%A9-%D8%A7%D9%84%D9%85%D9%86%D9%88%D8%B1%D8%A9-45850542"
                );
              }}
            >
              <FaLinkedinIn color="#000" size={17} />
            </Col>

            <Col
              className="takaful--contactUs-icon-container"
              xxl={4}
              xl={4}
              lg={5}
              md={5}
              sm={5}
              xs={5}
              onClick={() => {
                window.open("https://x.com/takafulsa");
              }}
            >
              <FaXTwitter color="#000" size={17} />
            </Col>
            <Col
              xxl={4}
              xl={4}
              lg={5}
              md={5}
              sm={5}
              xs={5}
              className="takaful--contactUs-icon-container"
              onClick={() => {
                window.open("https://www.youtube.com/takafulsa");
              }}
            >
              <TbBrandYoutube color="#000" size={17} />
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default ContactDetails;
